import format from 'date-fns/format';
import { observer } from 'mobx-react-lite';
import { Grid, Header, Segment } from 'semantic-ui-react';
import { PermitFormValues } from '../../../../app/models/permit';
import { useStore } from '../../../../app/stores/store';
import EveningTimeSelectInputs2 from './EveningTimeSelectInputs2';
import MorningTimeSelectInputs2 from './MorningTimeSelectInputs2';
import { addDays } from "date-fns";
import LoadingComponent from '../../../../app/layout/LoadingComponent';

interface Props {
    values: PermitFormValues,
    handleChange: (name: string|object, value: string|object) => void,
    morningError: boolean;
    eveningError: boolean;
}

export default observer(function PermitFormStep2Week2({ 
    values,
    handleChange,
    morningError,
    eveningError
 }: Props) {
    const {permitStore} = useStore();
    const {
        getAmTimeByDay,
        getPmTimeByDay,
        amTimeOptions,
        pmTimeOptions,
        getTerminalName
    } = permitStore;

    return (
        <>
            <Grid.Column width={16}>
                <Header as='h3' inverted block>Week 2 Schedule: Beginning Monday {format(addDays(new Date(values.dateWeekBegin), 7), 'M/d/yyyy')}</Header> 
            </Grid.Column>
            <Grid.Column computer={8} tablet={8} mobile={16} color={morningError ? 'red' : undefined}>
                <Segment>
                    <Header 
                        as='h3'
                        content={`Leave ${getTerminalName('' + values.amTerminalId)}`}
                        block
                        inverted
                        textAlign='center'
                    />
                    <Header 
                        as='h3'
                        content={`Morning  Departures`}
                        textAlign='center'
                        dividing
                    />

                    {amTimeOptions.length === 0 ? (
                         <LoadingComponent content='Loading schedules...' />
                    ) : ( 
                        <MorningTimeSelectInputs2
                            values={values}
                            getAmTimeByDay={getAmTimeByDay} 
                            handleChange={handleChange}
                        />
                    )}
                </Segment>
            </Grid.Column>
            
            <Grid.Column computer={8} tablet={8} mobile={16} color={eveningError ? 'red' : undefined}>
                <Segment>
                    <Header 
                        as='h3'
                        content={`Leave ${getTerminalName('' + values.pmTerminalId)}`}
                        block
                        inverted
                        textAlign='center'
                    />
                    <Header 
                        as='h3'
                        content={`Evening  Departures`}
                        textAlign='center'
                        dividing
                    />

                    {pmTimeOptions.length === 0 ? (
                         <LoadingComponent content='Loading schedules...' />
                    ) : ( 
                        <EveningTimeSelectInputs2
                            values={values}
                            getPmTimeByDay={getPmTimeByDay} 
                            handleChange={handleChange}
                        />
                    )}
                </Segment>
            </Grid.Column>
        </>
    )
})